import { VAT_RATES } from '@wf/shared'

// MwSt-Satz-Auswahl (V = 19 %, E = 7 %, o = ohne). Die Sätze kommen aus @wf/shared (EINE Wahrheit, kein
// hartkodierter Zweit-Satz). Wert/Callback arbeiten mit dem Satz als Zahl (19/7/0), exakt wie die DTOs.
const VAT_LABEL: Record<number, string> = { 19: '19 % (V)', 7: '7 % (E)', 0: 'ohne (o)' }

export function VatSelect({ value, onChange, label }: { value: number; onChange: (rate: number) => void; label: string }) {
  return (
    <select className="wf-input wf-line__vat" aria-label={label} value={value} onChange={(e) => onChange(Number(e.target.value))}>
      {VAT_RATES.map((rate) => (
        <option key={rate} value={rate}>
          {VAT_LABEL[rate] ?? `${rate} %`}
        </option>
      ))}
    </select>
  )
}
